import { Input, InputProps } from 'antd';
import { useFormContext, Controller } from 'react-hook-form';
import MaskedInput from 'antd-mask-input';

interface FormInputProps extends InputProps {
  name: string;
  isCurrencyInput?: boolean;
}

export const FormInput = ({ name, defaultValue, isCurrencyInput, ...props }: FormInputProps) => {
  const { control } = useFormContext();

  if (!isCurrencyInput)
    return (
      <Controller
        name={name}
        control={control}
        render={({ field: { value, onChange } }) => <Input value={value} onChange={onChange} {...props} />}
      />
    );

  // TODO (adam): if there is other place need text mask, i will make it generic
  return (
    <Controller
      name={name}
      control={control}
      key={name}
      render={({ field: { value, onChange } }) => (
        <MaskedInput
          mask={[
            {
              mask: /^\d{1,8}$|(?=^.{1,11}$)^\d+\.\d{0,2}$/,
              // ^\d{1,8}$ The numbers in this part are used to limit the integer digits,currently, this example restricts 8-bit integers
              //?=^.{1,11}$ The numbers in this part are used to limit the integers + decimals + decimal places,currently,11-bit
              //.\d{0,2}$  The numbers in this part are used to limit the decimals,currently,2-bit
            },
          ]}
          value={value}
          onChange={onChange}
          {...props}
        />
      )}
    />
  );
};
